import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import { theme as toyotaTheme } from "../theme/toyotaTheme";
import { IconWrapper } from "../globals/IconWrapper";

export const Wrapper = styled.section<{ height?: number | null; top?: number | null }>`
    ${({ height, top }) =>
        height &&
        top &&
        css`
            position: fixed;
            top: ${top}px;
            left: 0;
            right: 0;
            height: ${height}px;
            z-index: ${toyotaTheme.zIndex.overlay};
            @media ${getBreakpoint("up", "md")} {
                top: 100%;
                height: initial;
            }
        `}
    color: ${toyotaTheme.colors.primaryBlack};
    background-color: ${toyotaTheme.colors.primaryWhite};
    overflow: hidden;
`;

export const Header = styled.header`
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: flex-start;
    height: 110px;
    padding: ${toyotaTheme.space[3]}px;
    font-family: ${toyotaTheme.fonts.regular};
    background-color: ${toyotaTheme.colors.primaryWhite};
    cursor: pointer;
    z-index: 100;

    ${IconWrapper} {
        width: 24px;
        margin-right: ${toyotaTheme.space[2]}px;
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            margin-left: ${toyotaTheme.space[2]}px;
            margin-right: 0;
        }
    }
`;

export const Body = styled.div`
    transition: transform 0.25s ease-in-out;
`;

export const Panel = styled.div<{ top?: number | null }>`
    position: relative;
    width: 100vw;
    overflow: hidden;
`;
